import styled from 'styled-components';
import { Card } from '@mlc/web-ui-toolkit';

/*
There is a bug in Chrome that makes the bottom scroll bar shorter after the container has been focused.
Making a change to the CSS e.g. position, margin, etc. seems to reset it to normal
TODO: see if there is a better solution (this is nothing but a QoL change so will do later)
*/

export const DoubleScrollContainer = styled(Card)`
	position: relative;

	&:focus {
		position: initial;
	}
`;
